export default function OrganizationSchema() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'The Vertex',
    url: 'https://thevertex.com',
    description: 'Independent journalism for the curious mind — in-depth reporting at the intersection of technology, business, design, and culture.',
    email: 'hello@thevertex.com',
    telephone: '+1-212-555-0192',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '244 Madison Avenue',
      addressLocality: 'New York',
      addressRegion: 'NY',
      postalCode: '10016',
      addressCountry: 'US',
    },
    sameAs: [
      'https://twitter.com/thevertex',
      'https://linkedin.com/company/thevertex',
      'https://instagram.com/thevertex',
      'https://youtube.com/@thevertex',
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}